import { createTestId } from 'aem-libs-tests/src/utility/createTestId'
import { inputTestIds } from 'aem-libs-tests/src/utility/inputTestIds'

import { APP_NAME } from '../constants'

const installmentAmountInputBase = `${APP_NAME}--installment-amount-input`
const accountNumberInputBase = `${APP_NAME}--account-number-input`
const wholeAmountToggleBase = `${APP_NAME}--whole-amount-toggle`
export const testIds = {
  installmentAmountInputBase,
  accountNumberInputBase,
  accountNumberInput: createTestId(accountNumberInputBase, 'input'),
  paymentDateInput: `${APP_NAME}--payment-date-input`,
  installmentAmountInput: inputTestIds(installmentAmountInputBase),
  wholeAmountToggleBase,
  wholeAmountToggle: createTestId(wholeAmountToggleBase, 'input'),
  resultDate: `${APP_NAME}--result-date`
}
